import React from 'react';

/**
 * Elegant Step Indicator Component
 * Minimal monochromatic design
 */
const StepIndicator = ({ currentStep }) => {
  const steps = [1, 2, 3];

  const getStepStyle = (step) => {
    const baseStyle = {
      width: '20px',
      height: '20px',
      borderRadius: '50%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: '0.7rem',
      fontWeight: '500',
      fontFamily: '"Inter", "Segoe UI", system-ui, sans-serif',
      transition: 'all 0.2s ease'
    };

    if (step < currentStep) {
      // Completed - dark grey
      return {
        ...baseStyle,
        backgroundColor: '#4a5568',
        color: '#fff'
      };
    } else if (step === currentStep) {
      // Current - primary purple
      return {
        ...baseStyle,
        backgroundColor: '#667eea',
        color: '#fff'
      };
    } else {
      // Future - light outline
      return {
        ...baseStyle,
        backgroundColor: 'transparent',
        border: '1px solid #cbd5e0',
        color: '#a0aec0'
      };
    }
  };

  const lineStyle = (afterStep) => ({
    width: '24px',
    height: '1px',
    backgroundColor: afterStep < currentStep ? '#4a5568' : '#e2e8f0'
  });

  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      gap: '0',
      marginBottom: '0.75rem'
    }}>
      {steps.map((step, index) => (
        <React.Fragment key={step}>
          <div style={getStepStyle(step)}>{step}</div>
          {index < steps.length - 1 && <div style={lineStyle(step)} />}
        </React.Fragment>
      ))}
    </div>
  );
};

export default StepIndicator;
